import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { APICONSTANTS } from '../../constants/api-constants';
import { GenericLibelleService } from '../basic/generic-libelle.service';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class CgChargeService extends GenericLibelleService<CgChargeModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTECGCHARGE, hostnameService);
  }
}
